module.exports = __webpack_public_path__ + "img/brand (6).273240d4.svg";